import React from 'react';
import { useParams } from 'react-router-dom';
import { AppShell, useMantineTheme, Tabs } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { useLoginContext } from "../../context/loginContext";

import IdleTimer from "../../idleTimer/idleTimer";
import { brand, utils, role, menuListSU } from "../../utils/globalVariables";

import HeaderNavSU from "../../layout/HeaderNavSU";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import SUDataUserIndex from "../../pagesSub/superUserDataUser/SUDataUserIndex";
import SUUtilitiesIndex from "../../pagesSub/superUserUtilities/SUUtilitiesIndex";
import SUAplikasiUtilitasIndex from "../../pagesSub/superUserAplikasiUtilitas/SUAplikasiUtilitasIndex";

const SuperUserHome = () => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    const { tab } = useParams();

    const matchesMinSM = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const roleUser = role.super_user;
    const slugLink = roleUser.subLevel.super_user.slugLink;

    React.useEffect(() => {
        document.title = brand.longName;

        return () => {
            mountedRef.current = false;
        };
    }, []);

    React.useEffect(() => {
        const timer = utils.useIdleTimer === false ? null : new IdleTimer({
            localStorageIdleTimeName: role.super_user.localStorageIdleTimeName,
            onTimeout: () => {
                handleSetLoginContext(null)
            },
            onExpired: () => {
                if (!loginContext) {
                    handleSetLoginContext(null);
                } else {
                    if (!loginContext.hasOwnProperty('syswebapp')) {
                        handleSetLoginContext(null);
                    }
                }
            },
            onInterval: () => {
                /* some codes */
            }
        });

        return () => utils.useIdleTimer === false ? null : timer.cleanUp();
    }, [handleSetLoginContext, loginContext]);

    return (
        <React.Fragment>
            <AppShell
                styles={() => ({
                    main: {
                        // backgroundColor: matchesMinSM ? (theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[8]) : (theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8]),
                        paddingTop: matchesMinSM ? 'var(--mantine-header-height, 0px)' : 'var(--mantine-header-height, 0px)',
                        paddingRight: '0',
                        paddingLeft: '0',

                        // width: 'calc(100vw - 2rem)',

                        backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[8],
                    },
                })}

                hidden={false}
            >
                <WrapperHeaderTab>
                    <HeaderNavSU />

                    <WrapperTab
                        stateNavigate={`/${slugLink}/`}
                        stateKeepMounted={false}
                    >
                        <Tabs.Tab value={menuListSU.subMenu.one.tabs.one.flag}>
                            {menuListSU.subMenu.one.tabs.one.name}
                        </Tabs.Tab>

                        <Tabs.Tab value={menuListSU.subMenu.one.tabs.two.flag}>
                            {menuListSU.subMenu.one.tabs.two.name}
                        </Tabs.Tab>

                        <Tabs.Tab value={menuListSU.subMenu.one.tabs.three.flag}>
                            {menuListSU.subMenu.one.tabs.three.name}
                        </Tabs.Tab>
                    </WrapperTab>
                </WrapperHeaderTab>

                <Tabs value={tab} keepMounted={false}>
                    <Tabs.Panel value={menuListSU.subMenu.one.tabs.one.flag}>
                        <SUDataUserIndex />
                    </Tabs.Panel>

                    <Tabs.Panel value={menuListSU.subMenu.one.tabs.two.flag}>
                        <SUUtilitiesIndex />
                    </Tabs.Panel>

                    <Tabs.Panel value={menuListSU.subMenu.one.tabs.three.flag}>
                        <SUAplikasiUtilitasIndex />
                    </Tabs.Panel>
                </Tabs>
            </AppShell>

        </React.Fragment>
    )
}

export default SuperUserHome;